import { propsMap } from '@/presentation/interfaces';

export const sizes: propsMap = {
  s: '1.875rem',
  m: '2.188rem',
  l: '2.813rem',
};

export const weights: propsMap = {
  regular: '400',
  medium: '500',
  semiBold: '600',
  bold: '700',
};

export const lineHeights: propsMap = {
  s: '2.188rem',
  m: '2.5rem',
  l: '2.813rem',
};

export const letterSpacings: propsMap = {
  s: '0',
  m: '0',
  l: '-0.031rem',
};
